module.exports = __webpack_public_path__ + "img/GER.9babfbe0.png";